<template>
    <div>
        <BaseAccordion :title="'Film'">
            <BaseDropdown v-if="this.$route.path === '/seed'"
                          title="Part Status"
                          :options="statusOptions"
                          v-model="statusSelect"
                          @change="setStatusSelect" />
            <BaseDropdown title="Series"
                          v-model="seriesSelect"
                          :options="seriesOptions"
                          @change="setSeriesSelect" />
            <BaseDropdown title="Lead Spacing (mm) [SMD: varies]"
                          v-model="sizeSelect"
                          :options="sizeOptions"
                          @change="setSizeSelect" />
            <BaseDropdown title="Voltage Rating (VDC)"
                          v-model="voltageSelect"
                          :options="voltageOptions"
                          @change="setVoltageSelect" />
        </BaseAccordion>
        <BaseAccordion title="Available Parts" class="e-parts">
            <CapacitorResults :items="capacitorList" />
        </BaseAccordion>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    import CapacitorResults from './CapacitorResults.vue';

    import { createNamespacedHelpers } from 'vuex';
    const { mapState, mapActions } = createNamespacedHelpers('film');

    export default Vue.extend({
        components: {
            CapacitorResults,
        },
        mounted() {
            this.getSeriesOptions();
        },
        computed: {
            ...mapState([
                'statusSelect',
                'statusOptions',
                'seriesSelect',
                'seriesOptions',
                'sizeSelect',
                'sizeOptions',
                'voltageSelect',
                'voltageOptions',
                'capacitorList'
            ])
        },
        methods: {
            ...mapActions([
                'setStatusSelect',
                'setSeriesSelect',
                'setSizeSelect',
                'setVoltageSelect',
                'getSeriesOptions',
                'getSizeOptions',
                'getVoltageOptions',
                'getCapacitors'
            ]),
        },
        watch: {
            statusSelect() {
                this.getSeriesOptions();
                this.getSizeOptions();
                this.getVoltageOptions();
                this.getCapacitors();
            },
            seriesSelect() {
                this.getSizeOptions();
                this.getVoltageOptions();
                this.getCapacitors();
            },
            sizeSelect() {
                this.getVoltageOptions();
                this.getCapacitors();
            },
            voltageSelect() {
                this.getCapacitors();
            }
        },
    })
</script>

<style>
</style>